import { useEffect } from 'react';
import { StorageKey } from '../enum/StorageKey';
import { TokenResponse } from '../interface/response/TokenResponse';
import { setUserName } from '../store/slice/config/config';
import { decodeJwt } from '../util/decode-JWT';
import { getItemFromLocalStorage } from '../util/local-storage';
import { useAppDispatch } from './useAppDispatch';
import { ACCESS_TOKEN_CHANGED_EVENT } from '../constant/constants';

export const useUsernameFromAccessToken = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const setUsernameFromToken = () => {
      const accessToken = getItemFromLocalStorage(StorageKey.ACCESS_TOKEN)?.trim();

      if (!accessToken) return;

      const payload = decodeJwt<TokenResponse>(accessToken);

      dispatch(setUserName(payload.name));
    };

    setUsernameFromToken();

    window.addEventListener(ACCESS_TOKEN_CHANGED_EVENT, setUsernameFromToken);

    return () => {
      window.removeEventListener(ACCESS_TOKEN_CHANGED_EVENT, setUsernameFromToken);
    };
  }, [dispatch]);
};
